import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
import Swal from 'sweetalert2';
import { 
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import AddTipoAtencion from './AddTipoAtencion';


function GestionTipoAtencion() {
    const { tienePermiso } = useAccesos();

    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [tiposAtencion, setTiposAtencion] = useState([]);
    const [editTipoAtencion, setEditTipoAtencion] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [tipoAtencionToDelete, setTipoAtencionToDelete] = useState(null);
    const { user } = useUser();   


    const fetchTiposAtencion = async () => {
            try {
                const response = await fetch(`${server}/MgTipoAtencions`);
                const data = await response.json();
                setTiposAtencion(data.$values);
                
            } catch (error) {
                console.error('Error al cargar los Tipos de atención:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar los Tipos de atención: ' + error,
                });
            }
        };

    
    
        useEffect(() => {
            fetchTiposAtencion();
        }, []);
    
        const handleNewTipoAtencion = () => {
            fetchTiposAtencion();
            setEditTipoAtencion(null);
        };
    
        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };
    
        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };
    
        const handleSearchChange = (event) => {
            setSearchQuery(event.target.value);
        };
    
        const handleOpenDialog = (tipoAtencion) => {
            setTipoAtencionToDelete(tipoAtencion);
            setOpenDialog(true);
        };
    
        const handleCloseDialog = () => {
            setOpenDialog(false);
            setTipoAtencionToDelete(null);
        };
    
        const handleDeleteTipoAtencion = async () => {
            if (tipoAtencionToDelete) {
                try {
                    const username = ''+user.codigoUsuario+'/';
    
                    const response = await fetch(`${server}/MgTipoAtencions/${tipoAtencionToDelete.id}/${username}`,
                         {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        handleCloseDialog();
                        fetchTiposAtencion(); // Recargar la lista de razas
                        Swal.fire({
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Tipo de Atención eliminado con éxito',
                        });
                    } else {
                        handleCloseDialog();
    
                        const errorData = await response.json();
                        const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                        Swal.fire({
                            icon: 'error',
                            title: `Error ${response.status}`,
                            text: errorMessage,
                        });
                    }
                } catch (error) {
                    console.error('Error al eliminar el tipo de atención:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al eliminar el tipo de atención: ' + error,
                    });            }
            }
        };
    
        const filteredTipoAtencion = tiposAtencion.filter(tipoAtencion => tipoAtencion.tipoAtencion?.toLowerCase().includes(searchQuery.toLowerCase()));
    
   const handleCancelarEdicion = () => {
        setEditTipoAtencion(null);
   };

        return (
    <>
        <div className="x_title">
            </div>

            <div className="x_content">
                <br />

                <AddTipoAtencion handleNewTipoAtencion={handleNewTipoAtencion} editTipoAtencion={editTipoAtencion} cancelarEdicion={handleCancelarEdicion} />

                <div className="ln_solid" />

                <h2>Tipos de Atención existentes</h2>

                <div className="row">
                    <div className="col-md-6 col-sm-4 offset-md-3">
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Buscar Tipo de Gasto"
                            placeholder="Buscar..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />

                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Descripción</TableCell>
                                            <TableCell align="right">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredTipoAtencion.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((tipoAtencion) => (
                                                <TableRow key={tipoAtencion.id}>
                                                    <TableCell component="th" scope="row">
                                                        {tipoAtencion.tipoAtencion}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Button onClick={() => setEditTipoAtencion(tipoAtencion)} color="primary" disabled={!tienePermiso('Editar Tipo Atención')}>
                                                            Editar
                                                        </Button>
                                                        <Button onClick={() => handleOpenDialog(tipoAtencion)} color="secondary" disabled={!tienePermiso('Eliminar Tipo Atención')}>
                                                            Eliminar
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        
                                    </TableBody>
                                </Table>

                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredTipoAtencion.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>

                            <Dialog open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description">
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que quieres eliminar este tipo de atención?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                    <Button onClick={handleDeleteTipoAtencion} color="primary" autoFocus>Eliminar</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </>

     
    );
}

export default GestionTipoAtencion;